// src/components/CustomerSummary/components/DeviceUtilizationTable.jsx
// ============================================================================
// BLOCK CS.UI.DU.0 — DeviceUtilizationTable (read-only + resizable)
// ----------------------------------------------------------------------------
// INPUT FORMAT (tab-delimited; 3 columns)
// - Group header rows (metric label only): "<Metric>\t\t"
// - Nested rows: "\t<Device Group>\t<Value>"
// ============================================================================

import React from 'react';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

export default function DeviceUtilizationTable({ text, columnWidths, onColumnWidthsChange }) {
  return (
    <ResizableTextTable
      text={text}
      columnWidths={columnWidths}
      onColumnWidthsChange={onColumnWidthsChange}
      format={TABLE_FORMATS.deviceUtilization}
    />
  );
}
